"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ensureNumber_1 = require("../conversion/ensureNumber");
exports.numRange = function (start, end, step) {
    if (step === void 0) { step = 1; }
    var startNum = ensureNumber_1.ensureNumber(start);
    if (isNaN(startNum)) {
        throw new Error("numRange start requires digit");
    }
    var endNum = ensureNumber_1.ensureNumber(end);
    if (isNaN(endNum)) {
        throw new Error("numRange end requires digit");
    }
    var stepNum = ensureNumber_1.ensureNumber(step);
    if (isNaN(stepNum)) {
        throw new Error("numRange step requires digit");
    }
    if (stepNum === 0)
        throw new Error("numRange step cannot be 0");
    if (startNum === endNum)
        return [startNum];
    if ((startNum > endNum && stepNum > 0) || (startNum < endNum && stepNum < 0)) {
        stepNum *= -1;
    }
    var arr = [];
    for (var i = startNum; ((startNum < endNum) ? (i < endNum) : (i > endNum)); i += stepNum) {
        arr.push(i);
    }
    return arr;
};
exports.alphaRange = function (start, end, step) {
    if (step === void 0) { step = 1; }
    if (start.length !== 1) {
        throw new Error("alphaRange start must be single character");
    }
    if (end.length !== 1) {
        throw new Error("alphaRange end must be single character");
    }
    var stepNum = ensureNumber_1.ensureNumber(step);
    if (isNaN(stepNum)) {
        throw new Error("numRange step requires digit");
    }
    if (stepNum === 0)
        throw new Error("numRange step cannot be 0");
    if (start === start.toUpperCase()) {
        end = end.toUpperCase();
    }
    else if (start === start.toLowerCase()) {
        end = end.toLowerCase();
    }
    if (start === end)
        return [start];
    var startCharCode = start.charCodeAt(0);
    var endCharCode = end.charCodeAt(0);
    if ((startCharCode > endCharCode && stepNum > 0) || (startCharCode < endCharCode && stepNum < 0)) {
        stepNum *= -1;
    }
    return exports.numRange(startCharCode, endCharCode, stepNum).map(function (n) { return String.fromCharCode(n); });
};
